import { render, staticRenderFns } from "./EditBtnGroup.vue?vue&type=template&id=4d524c68&scoped=true&"
import script from "./EditBtnGroup.vue?vue&type=script&lang=js&"
export * from "./EditBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditBtnGroup.vue?vue&type=style&index=0&id=4d524c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d524c68",
  null
  
)

export default component.exports